import React from "react";
import DashboardHeader from '../../components/admincomponents/DashboardHeader';
import ShareholdersList from '../../components/admincomponents/ShareholdersList';

function Projects({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <ShareholdersList  />            
    </>
  );
}

export default Projects;
